<template>
    <div class="new-transaction-form">
        <form @submit.prevent="store" class="new-transaction-container">
            <h2>{{ $t('Новая операция') }}</h2>

            <!-- <div class="form-group">
                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('description')}" v-model="form.description" :placeholder="$t('Поиск по операциям')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('description')">{{ getError('description') }}</span> -->

            <div class="form-group datepicker-group mb-5">
                <date-picker v-model="form.date" :config="options"></date-picker>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('date')">{{ getError('date') }}</span>

            <div class="btn-group transaction-btn-group">
                <button type="button" 
                    v-for="type in types" 
                    :key="type.key" 
                    @click="form.type = type" 
                    :class="{'btn': true, 'btn-blue': form.type && form.type.key == type.key, 'btn-light': !form.type || form.type.key != type.key}">
                    {{ $t(type.name) }}
                </button>
            </div>

            <div class="form-group">
                <multiselect 
                    v-model="form.account" 
                    :options="filteredAccounts" 
                    :custom-label="nameWithBalance" 
                    label="title" 
                    track-by="id" 
                    class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ nameWithBalance(props.option) }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{  form.type && form.type.key == 'transfer' ? $t('Со счета')  : $t('Счет') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('account')">{{ getError('account') }}</span>

            <div :class="{'transaction-amount-input-group': true, 'income': form.type && form.type.key == 'income', 'transfer': form.type && form.type.key == 'transfer'}">
                <input type="text" 
                    :class="{'form-control transaction-amount': true, 'is-invalid': hasError('amount')}" 
                    :value="form.amount != null ? form.amount / 100 : null"
                    @input="form.amount = parseInt($event.target.value * 100)"
                    placeholder="0">
                
                <multiselect 
                    v-model="form.currency" 
                    :searchable="false" 
                    :allow-empty="false" 
                    :options="currencies" 
                    :placeholder="null" 
                    label="symbol" 
                    track-by="id" 
                    class="form-control transaction-amount-currency">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.symbol }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div></div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('amount')">{{ getError('amount') }}</span>

            <div class="form-group" v-if="form.type && form.type.key != 'transfer'">
                <multiselect 
                    v-model="form.category" 
                    :options="filteredCategories" 
                    :placeholder="$t('Категория')" 
                    label="name" 
                    track-by="id" 
                    class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Категория') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('category')">{{ getError('category') }}</span>

            <div class="form-group" v-if="form.type && form.type.key == 'transfer'">
                <multiselect 
                    v-model="form.to_account" 
                    :options="filteredAccounts" 
                    :custom-label="nameWithBalance" 
                    label="title" 
                    track-by="id" 
                    class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ nameWithBalance(props.option) }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('На счет') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('to_account')">{{ getError('to_account') }}</span>

            <div class="form-group mt-5">
                <textarea :class="{'form-control': true, 'is-invalid': hasError('comment')}" v-model="form.comment" :placeholder="$t('Комментарий / Заметка (не обязательно)')" rows="3"></textarea>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('comment')">{{ getError('comment') }}</span>

            <template v-if="isFuture">
                <div class="info-tip mt-5">
                    Дата операции выбрана как будущая, в таком случае операция будет добавлена как "Напоминание".
                </div>

                <div class="checkbox-group mt-10 mb-10">
                    <input :id="`auto-complete-checkbox`" v-model="form.auto_complete" type="checkbox">
                    <label :for="`auto-complete-checkbox`" class="checkbox-label">
                        Добавить операцию автоматически?
                    </label>
                </div>

                <div class="info-tip mb-10">
                    Если вы укажете автоматическое добавление операции, она будет создана из напоминаня автоматически в указанный вами счет.
                </div>
            </template>

            <template v-if="form.account && form.account.budgets.length !== 0">
                <div class="form-group mt-10">
                    <label class="mb-0">{{ $t('Включить операцию в бюджеты') }}:</label>
                </div>
                
                <div class="checkbox-group mt-10 mb-10" v-for="budget in form.account.budgets" :key="budget">
                    <input :id="`budget-checkbox-${budget}`" v-model="form.budgets[budget]" type="checkbox">
                    <label :for="`budget-checkbox-${budget}`" class="checkbox-label">
                        {{ getBudget(budget).name }}
                    </label>
                </div>
            </template>

            <button type="submit" class="btn btn-form btn-blue mt-5">{{ $t('Добавить') }}</button>
        </form>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState, mapGetters } from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import { EventBus } from '../../../event-bus';

export default {
    name: "NewTransaction",

    components: {
        datePicker,
    },

    props: ['isSideForm'],

	data: function() {
        return {
            form: {
                type: {name: 'Трата', icon: 'fa-minus', key: "outcome"},
                date: new Date(),
                amount: null,
                currency: {id: 0, title: "UAH"},
                auto_complete: true,
                account: null,
                to_account: null,
                category: null,
                description: null,
                budgets: {},
            },

            options: {
                format: 'DD.MM.YYYY',
                useCurrent: true,

                icons: {
                    previous: 'icon icon-chevron-left',
                    next: 'icon icon-chevron-right',
                }
            },

            types: [
                {name: 'Трата', key: "outcome"},
                {name: 'Доход', key: "income"},
                {name: 'Перевод', key: "transfer"},
            ],

            errors: {},
        };
    },

    mounted() {
        this.loadCategories();
        this.loadAccounts();
        this.loadBudgets();

        this.form.currency = this.currency;
    },

    watch: {
        'form.amount': function() {
            delete this.errors['amount'];
        },
        'form.account': function() {
            if(this.form.account) {
                for(let i = 0; i < this.form.account.budgets.length; i++) {
                    this.form.budgets[this.form.account.budgets[i]] = true;
                }

                this.form.currency = this.form.account.currency;
            }

            delete this.errors['account'];
        },
        'form.to_account': function() {
            delete this.errors['to_account'];
        },
        'form.category': function() {
            delete this.errors['category'];
        },
        'form.description': function() {
            delete this.errors['description'];
        }
    },

    computed: {
        ...mapGetters(['categories', 'accounts', 'budgets', 'currency', 'currencies']),

        filteredCategories: function() {
            if(this.form.type.key == 'income') {
                return this.categories.filter((category) => {
                    return category.incomes;
                });
            }

            if(this.form.type.key == 'outcome') {
                return this.categories.filter((category) => {
                    return category.expenses;
                });
            }

            return this.categories;
        },

        filteredAccounts: function() {
            return this.accounts.filter((account) => ! account.integrated);
        },

        isFuture: function() {
            return moment(this.form.date, 'DD.MM.YYYY').isAfter();
        }
    },

    methods: {
        ...mapActions(['loadCategories', 'loadAccounts', 'loadBudgets', 'loadReminders', 'loadTransactions']),

        store() {
            axios.post('/transactions', this.form)
                .then(({data}) => {
                    if(data.status === 'success') {
                        this.closeForm();

                        this.loadTransactions({page: 1});
                        this.loadReminders();

                        EventBus.$emit('show-alert', data.message ? data.message : $('Операция добавлена'), 'success');
                    }
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        closeForm() {
            EventBus.$emit('close-side-form');

            this.form = {
                type: {name: 'Трата', icon: 'fa-minus', key: "outcome"},
                date: new Date(),
                amount: null,
                currency: this.currency,
                auto_complete: true,
                account: null,
                to_account: null,
                category: null,
                description: null,
                budgets: {},
            };
        },

        getBudget(id) {
            return this.budgets.find((budget) => budget.id === id);
        },

        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);
            let currencySign = this.$options.filters.currency(currency); 

            return `${title} — ${balance} ${currencySign}`;
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.new-transaction-form {
    .new-transaction-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            background: transparent;
            padding: 0 24px;
            width: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }

        input.form-control {
            width: calc(100% - 24px);
        }

        .form-group {
            .multiselect {
                margin-top: 10px;
            }
        }

        .transaction-amount-input-group {
            display: flex;
            align-items: center;
            position: relative;

            &:before {
                content: "-";
                position: absolute;
                top: 27%;
                left: 15px;
                font-size: 20px;
            }

            &.income {
                &:before {
                    content: "+";
                    font-size: 17px;
                    top: 33%;
                }
            }

            &.transfer {
                &:before {
                    content: "";
                    background-repeat: no-repeat;
                    background-position: center;
                    mask-repeat: no-repeat;
                    mask-position: center;
                    background-image: none;
                    mask-size: contain;
                    background-size: contain;
                    mask-image: url("../../../assets/images/icons/chevron-right.svg");
                    background-color: #152640;
                    top: 39%;
                    left: 12px;
                    width: 12px;
                    height: 12px;
                }
            }

            .transaction-amount {
                padding-left: 30px;
            }

            .transaction-amount-currency {
                width: 15%;
                margin-left: 12px;
            }
        }

        .transaction-btn-group {
            margin-bottom: 8px;

            .btn {
                margin: 0;
                border-radius: 0;

                &:first-child {
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                }

                &:last-child {
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                }
            }
        }
    }
    
    .info-tip {
        font-size: 12px;
        font-family: 'Proxima Nova Rg';
        color: rgba(#152640, .5);
    }
}
</style>